export class StoryPerson {
  public id: string;
  public name: string;

  constructor(data: Partial<StoryPerson> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: Partial<StoryPerson> = {}): StoryPerson {
    return new StoryPerson(data);
  }
}
